import React from "react";
import { AppContext } from "../../../contexts/AppContext";
import Format from "../../../helpers/Format";
import Moment from "react-moment";
import PropTypes from "prop-types";

function RecompensasTabela({ recompensas, excluirRecompensa }) {
  const { session } = React.useContext(AppContext);

  return (
    <div className="table-responsive">
      <table className="table table-nowrap" id="tableRecompensas">
        <tbody>
          {recompensas.map((recompensa, index) => (
            <tr style={{ height: "100px" }} key={index}>
              <td
                style={{
                  width: parseInt(session.codigo) >= 10 ? "75%" : "90%",
                }}
              >
                <h5 className="text-truncate font-size-14 m-0">
                  {recompensa.razao_indicada}
                </h5>
                <div>
                  <div className="mt-3">
                    <div className="position-relative">
                      <div className="progress" style={{ height: "10px" }}>
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: `${recompensa.porcentagem}%` }}
                          aria-valuenow="50"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        />
                      </div>
                      <span
                        className={`badge
                          ${
                            recompensa.porcentagem >= 100
                              ? "bg-secondary"
                              : "bg-success"
                          }
                          mt-4 position-absolute start-10 btn-sm rounded-pill`}
                      >
                        Início:{" "}
                        <Moment format="MM/YYYY">
                          {recompensa.data_inicio}
                        </Moment>
                      </span>
                      <span
                        className={`badge
                          ${
                            recompensa.porcentagem >= 100
                              ? "bg-secondary"
                              : "bg-success"
                          }
                          mt-4 position-absolute start-100 translate-middle btn-sm rounded-pill`}
                      >
                        Fim:{" "}
                        <Moment format="MM/YYYY">{recompensa.data_fim}</Moment>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="text-center">
                  <span className="text-secondary font-size-22 m-0">
                    {parseInt(recompensa.tipo) === 1 ? (
                      <strong>{Format.formataValor(recompensa.valor)}</strong>
                    ) : (
                      <strong>{parseFloat(recompensa.valor) * 100}%</strong>
                    )}
                  </span>
                </div>
                <div className="text-center">
                  <span
                    className={`badge
                          ${
                            recompensa.porcentagem >= 100
                              ? "bg-secondary"
                              : "bg-success"
                          }`}
                  >
                    {recompensa.porcentagem >= 100 ? "Inativo" : "Ativo"}
                  </span>
                </div>
              </td>
              {parseInt(session.codigo) >= 10 ? (
                <td>
                  <button
                    type="button"
                    className="btn btn-transparent waves-effect waves-light btn-action apagarRecompensa"
                    title="Excluir recompensa"
                    onClick={() => {
                      excluirRecompensa(recompensa.id);
                    }}
                  >
                    <i className="mdi mdi-delete d-block font-size-18 text-danger"></i>
                  </button>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

RecompensasTabela.propTypes = {
  recompensas: PropTypes.arrayOf(PropTypes.object).isRequired,
  excluirRecompensa: PropTypes.func.isRequired,
};

export default RecompensasTabela;
